import { ThemeProvider } from '@frm/ui';
import { Routes, Route, Navigate } from 'react-router';
import LauncherPage from './pages/LauncherPage';
import LoginPage from './pages/LoginPage';

/**
 * Корневой компонент. Маршрутизация плоская:
 *   /         → каталог для авторизованных; анонимы уходят на /login?next=...
 *   /login    → workbench-экран входа с CTA на backend /api/auth/login
 *   *         → 404 → /
 */
export default function App() {
  return (
    <ThemeProvider className="launcher-app" defaultTheme="aurora-nocturne" service="ai.launcher">
      <Routes>
        <Route path="/" element={<LauncherPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ThemeProvider>
  );
}
